import React, { useMemo } from "react";

import Table from "components/table/Table";
import DefaultTextCell from "components/cells/DefaultTextCell";

import TeamCell from "./cells/TeamCell";

import CheckIcon from "icons/CheckIcon";
import { useMediaSize } from "util/useMediaSize";
import { Meet } from "types";

import get from "lodash/get";
import { getTeamDataForTable } from "util/teamScoring";

// prettier-ignore
const columns = [
    {key: 'team', label: 'Team', width: 250, renderer: TeamCell},
    {key: 'place', label: 'Place', width: 85, renderer: DefaultTextCell},
    {key: 'points', label: "Points", width: 110, renderer: DefaultTextCell}
  ];

const TeamResultsTable = ({ meet }: { meet: Meet }) => {
  const [forecasted, setForecasted] = React.useState(false);

  const media = useMediaSize();

  const data = useMemo(
    () => getTeamDataForTable({ meet, forecasted }),
    [forecasted, meet],
  );

  const getCellLines = (index: number) => {
    const team = get(data, index, {});
    if ("row" in team && team.row === "title") {
      return 1.1;
    }

    return 0.85;
  };

  return (
    <div style={{ height: "100%" }}>
      <div className="util-row">
        <div>
          Team Results By{" "}
          {meet.teamScoringMethod === "BY_FORMULA" ? "Formula" : "Placing"}
        </div>
        <button
          className="forecasted"
          onClick={() => setForecasted((prev) => !prev)}
        >
          Forecasted&nbsp;{forecasted && <CheckIcon />}
        </button>
      </div>

      <div className="table-wrapper">
        <Table
          data={data}
          numberOfFixedLeftColumns={1}
          columns={columns}
          getCellLines={getCellLines}
          meet={meet}
          scrollToAlignment="center"
          media={media}
          padBottom
        />
      </div>
    </div>
  );
};

export default TeamResultsTable;
